import { REQUEST } from 'Stores'
import { CHANGE_NAME, CREATE_FOLDER,
  CREATE_WEEKLY_NOTE, DELETE_FILE,
  GET_DRIVES_AND_NOTES, GET_DRIVES_HOT_LOAD,
  GET_FILES_T0_DOWNLOAD_FOLDER,
  GET_ONE_DRIVE, GET_PORTFOLIO_DATA, GET_WEEKLY_NOTE, MOVE_ITEM,
  REMOVE_FILES_T0_DOWNLOAD_FOLDER,
  UPDATE_WEEKLY_NOTE, UPLOAD_FILE, UPLOAD_FOLDER, OPEN_FILE } from './constants'

export function getOneDrive(payload) {
  return {
    type: REQUEST(GET_ONE_DRIVE),
    payload
  }
}

export function deleteItem(payload) {
  return {
    type: REQUEST(DELETE_FILE),
    payload
  }
}

export function changName(payload) {
  return {
    type: REQUEST(CHANGE_NAME),
    payload
  }
}

export function createFolder(payload) {
  return {
    type: REQUEST(CREATE_FOLDER),
    payload
  }
}

export function moveItem(payload) {
  return {
    type: REQUEST(MOVE_ITEM),
    payload
  }
}

export function uploadFile(payload) {
  return {
    type: REQUEST(UPLOAD_FILE),
    payload
  }
}

export function getNote(payload) {
  return {
    type: REQUEST(GET_WEEKLY_NOTE),
    payload
  }
}

export function updateNote(payload, conditionGetNotes, callback) {
  return {
    type: REQUEST(UPDATE_WEEKLY_NOTE),
    payload,
    conditionGetNotes,
    callback
  }
}

export function createNote(payload, conditionGetNotes, callback) {
  return {
    type: REQUEST(CREATE_WEEKLY_NOTE),
    payload,
    conditionGetNotes,
    callback
  }
}

export function getDrivesAndNotes(payload, conditionGetNotes) {
  return {
    type: REQUEST(GET_DRIVES_AND_NOTES),
    payload,
    conditionGetNotes
  }
}

export function getDrivesHotLoad(payload, callback) {
  return {
    type: REQUEST(GET_DRIVES_HOT_LOAD),
    payload,
    callback
  }
}

export function getPortfolio(payload) {
  return {
    type: REQUEST(GET_PORTFOLIO_DATA),
    payload
  }
}

export function getFilesToDownloadFolder(payload) {
  return {
    type: REQUEST(GET_FILES_T0_DOWNLOAD_FOLDER),
    payload
  }
}

export function removeFilesToDownloadFolder() {
  return {
    type: REQUEST(REMOVE_FILES_T0_DOWNLOAD_FOLDER)
  }
}

export function uploadFolder(payload) {
  return {
    type: REQUEST(UPLOAD_FOLDER),
    payload
  }
}

export function openFile(payload) {
  return {
    type: REQUEST(OPEN_FILE),
    payload
  }
}
